import React from 'react';
import { ProductGroupField as ProductGroupFieldType } from '../../types/optionTypes';

interface ProductGroupFieldProps {
    field: ProductGroupFieldType;
    value: any;
    onChange: (value: any) => void;
}

export const ProductGroupField: React.FC<ProductGroupFieldProps> = ({ field, value, onChange }) => {
    // Default to select if not specified
    const renderType = field.renderType || 'select';

    if (renderType === 'select') {
        return (
            <div className="w-full">
                {field.label && (
                    <label className="block text-sm font-medium text-gray-800 mb-2">
                        {field.label}
                        {field.required && <span className="text-red-500 ml-1">*</span>}
                    </label>
                )}

                <select
                    value={value || ''}
                    onChange={(e) => onChange(e.target.value)}
                    required={field.required}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors hover:border-gray-400"
                >
                    <option value="">{field.placeholder || 'ご選択ください'}</option>
                    {field.values.map((option) => (
                        <option key={option.tempId} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                {field.description && (
                    <div className="mt-1.5 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.description }} />
                )}
                {field.errorMessage && (
                    <p className="text-xs text-red-500 mt-1">{field.errorMessage}</p>
                )}
            </div>
        );
    }

    if (renderType === 'checkbox') {
        const currentValues = Array.isArray(value) ? value : [];

        const handleChange = (optionValue: string, checked: boolean) => {
            if (checked) {
                onChange([...currentValues, optionValue]);
            } else {
                onChange(currentValues.filter((v: string) => v !== optionValue));
            }
        };

        return (
            <div className="w-full">
                {field.label && (
                    <label className="block text-sm font-medium text-gray-800 mb-2">
                        {field.label}
                        {field.required && <span className="text-red-500 ml-1">*</span>}
                    </label>
                )}

                <div className="space-y-2.5 bg-gray-50 p-3 rounded-md border border-gray-200">
                    {field.values.map((option) => (
                        <label key={option.tempId} className="flex items-start space-x-2.5 cursor-pointer group hover:bg-white p-1.5 rounded transition-colors">
                            <input
                                type="checkbox"
                                checked={currentValues.includes(option.value)}
                                onChange={(e) => handleChange(option.value, e.target.checked)}
                                className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                            />
                            <span className="text-sm text-gray-700 leading-relaxed flex-1">{option.label}</span>
                        </label>
                    ))}
                </div>

                {field.description && (
                    <div className="mt-1.5 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.description }} />
                )}
                {field.errorMessage && (
                    <p className="text-xs text-red-500 mt-1">{field.errorMessage}</p>
                )}
            </div>
        );
    }

    // Fallback or other types (radio, etc.) can be added here
    return null;
};
